import { Pipe, PipeTransform } from '@angular/core';

import { sortArray } from '../utils/utility-functions.utils';
import { SortByTypeEnum } from './../enums/sort-by.enum';

@Pipe({
    name: 'sortBy',
})
export class SortBy implements PipeTransform {
    public transform(
        array: any[],
        key: string = 'label',
        type: SortByTypeEnum = SortByTypeEnum.STRING,
        direction: 'asc' | 'desc' = 'asc'
    ): any[] {
        if (array && array.length >= 1 && key) {
            return sortArray(array, key, direction, type);
        }
        return array;
    }
}
